





















import { Component, Vue, Prop } from 'vue-property-decorator';
import ReleaseNoteForm from '@/components/forms/ReleaseNoteForm.vue';
import { Route, RawLocation } from 'vue-router';
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate'
]);

@Component({
    components: {
        ReleaseNoteForm
    }
})
export default class NotificationEdit extends Vue {
    public $refs!: {
        releaseNoteForm: ReleaseNoteForm
    };

    @Prop() public id!: string | number;
    public beforeRouteUpdate(
        to: Route, from: Route, next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void) {
            this.$refs.releaseNoteForm.updateForm();
            next();
    }
}
